// extracted by mini-css-extract-plugin
module.exports = {"panelWrapper":"SplitterPanel__panelWrapper___3M-Kp","panelInner":"SplitterPanel__panelInner___2mbi6"};